export enum IOrderFields {
    Name = 'Name',
    Location = 'Description',
    Image = 'Image',
}

export interface IDeletePlaceForm {
    placeId?: number;
}
